interface AnalyticsIconProps {
  className?: string;
}

export default function NotificationsIcons({ className }: AnalyticsIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.4"
        d="M18.7501 8.99023V9.69423C18.7501 10.5392 18.9901 11.3652 19.4421 12.0682L20.5501 13.7912C21.5611 15.3652 20.7891 17.5042 19.0301 18.0012C14.4338 19.3032 9.56631 19.3032 4.97006 18.0012C3.21106 17.5042 2.43906 15.3652 3.45006 13.7912L4.55806 12.0682C5.01164 11.3596 5.25217 10.5356 5.25106 9.69423V8.99023C5.25106 5.12423 8.27306 1.99023 12.0001 1.99023C15.7271 1.99023 18.7501 5.12423 18.7501 8.99023Z"
        className="fill-grey-500"
      />
      <path
        d="M12.7499 5.99023C12.7499 5.79132 12.6709 5.60056 12.5302 5.4599C12.3896 5.31925 12.1988 5.24023 11.9999 5.24023C11.801 5.24023 11.6102 5.31925 11.4696 5.4599C11.3289 5.60056 11.2499 5.79132 11.2499 5.99023V9.99023C11.2499 10.1891 11.3289 10.3799 11.4696 10.5206C11.6102 10.6612 11.801 10.7402 11.9999 10.7402C12.1988 10.7402 12.3896 10.6612 12.5302 10.5206C12.6709 10.3799 12.7499 10.1891 12.7499 9.99023V5.99023ZM7.24292 18.5352C7.56967 19.5393 8.2058 20.4143 9.06021 21.0348C9.91463 21.6553 10.9435 21.9894 11.9994 21.9894C13.0554 21.9894 14.0842 21.6553 14.9386 21.0348C15.793 20.4143 16.4292 19.5393 16.7559 18.5352C13.6109 19.1252 10.3889 19.1252 7.24292 18.5352Z"
        className="fill-grey-500"
      />
    </svg>
  );
}
